// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alert-background-color": "rgb(255, 255, 255)",
	"alert-border-color": "rgb(224, 227, 228)",
	"alert-close-icon-color": "rgb(153, 153, 153)",
	"alert-text-color": "rgb(62, 57, 57)",
	"critical-accent-color": "rgb(247, 96, 86)",
	"critical-text-color": "rgb(209, 53, 42)",
	"info-accent-color": "rgb(86, 111, 184)",
	"info-text-color": "rgb(59, 78, 133)",
	"success-accent-color": "rgb(123, 201, 157)",
	"success-text-color": "rgb(45, 133, 96)",
	"warning-accent-color": "rgb(214, 174, 62)",
	"warning-text-color": "rgb(179, 97, 4)"
};
export default ___CSS_LOADER_EXPORT___;
